import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useAuthStore } from "@/ts/stores/auth";
import { CancelationData, CancelReason, CancelConfirmation } from "@/ts/components/members";
import { useUrlSearchParams } from "@vueuse/core";

interface Props {
    id?: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    id: { type: String, required: false }
  },
  setup(__props: any, { expose }) {
  expose();


const params = useUrlSearchParams("history");
const authStore = useAuthStore();
const step = ref(1);
const box = ref<HTMLDivElement>();
const boxHeight = ref();
const data = ref<CancelationData>({
    reasons: {
        reason: "",
        comment: "",
    },
});

if (params && params.renewal_key) {
    authStore.readUser(Array.isArray(params.renewal_key as string[]) ? params.renewal_key[0] : (params.renewal_key as string));
}

function calculateBoxHeight(height: number | undefined = undefined) {
    boxHeight.value = height ? height : box.value!.offsetHeight;
}

function nextStep(property: keyof typeof data.value, value: any) {
    (data.value as Record<string, any>)[property] = value;
    step.value++;
}

function undoRedirect() {
    window.location.href = `/lid-worden?renewal_key=${params.renewal_key}`;
}

const __returned__ = { params, authStore, step, box, boxHeight, data, calculateBoxHeight, nextStep, undoRedirect, CancelReason, CancelConfirmation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})